<template lang="pug">
    extends ../base/base.pug
    block input
        b-row
            b-col(md)
                label(
                    v-bind:for="slug + multi_field_num"
                )
                    = '{{ question }}'
                    span(
                        v-if="is_required"
                        class="requiredField"
                    ) *
            b-col(md)
                b-form-select(
                    v-model="local_answer"
                    :id="slug + multi_field_num"
                    @change="process_change()"
                    :required="is_required"
                    :state="get_state"
                    :options="options"
                )
                b-form-invalid-feedback
                    = '{{ error_message }}'
                b-form-text(v-html="helper")
</template>
<script>
import Base from "../base";

export default {
	extends: Base,
	computed: {
		options: {
			get() {
				return [
					{ value: "", text: "" },
					...this.$store.state[this.slug].options
				];
			}
		}
	}
};
</script>
